import React from 'react';
import ChamberGrid from './ChamberGrid';

/**
 * Raw Data workspace — renders the responsive CSS Grid of chamber charts.
 */
const RawDataWorkspace = ({ tabId }) => {
  return <ChamberGrid tabId={tabId} />;
};

export default RawDataWorkspace;
